var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('simple-header',{attrs:{"title":"Preloader","back-link":true}}),_vm._v(" "),_c('page-content',[_c('div',{staticClass:"demos-content-padded"},[_c('p',[_c('m-button',{nativeOn:{"click":function($event){_vm.showPreloader()}}},[_vm._v("Show Preloader")])],1)])]),_vm._v(" "),_c('preloader',{ref:"preloader"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-1b10c82f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/demos/Preloader.vue
// module id = null
// module chunks = 